import * as Sentry from '@sentry/browser'

const knownNoisyIssues = [
  'WonderPush',
  'Non-Error',
  "Can't find variable: ga",
  'ga is not defined',
  'ga.getAll is not a function',
  'Non-Error promise rejection captured with keys: currentTarget, detail, isTrusted, target',
  'GSI_LOGGER',
  'FedCM',
  'AbortError',
  'Failed to fetch (api.btloader.com)',
  'Load failed (api.btloader.com)',
  'NetworkError when attempting to fetch resource. (api.btloader.com)',
  'Failed to fetch (analytics.google.com)',
  'Failed to fetch (www.google-analytics.com)',
  'Failed to fetch (googletagmanager.com)',
  'Failed to fetch (pagead2.googlesyndication.com)',
  "Event `CustomEvent` (type=unhandledrejection) captured as promise rejection",
  "Failed to read a named property 'performance' from 'Window': An attempt was made to break through the security policy of the user agent",
  "Failed to read a named property 'performance' from 'Window': Blocked a restricted frame with origin",
  "Failed to read a named property 'clearTimeout' from 'Window': An attempt was made to break through the security policy of the user agent",
  "Failed to read a named property 'clearTimeout' from 'Window': Blocked a restricted frame with origin",
  'URIError',
  'URI malformed',
  'Load failed',
  'Got unexpected null or undefined',
  'Java bridge method invocation error',
]

// Common Sentry configuration
const sentryConfig = {
  dsn: 'https://5eb8d58117d14638858f28b39d3afe37@o159814.ingest.us.sentry.io/1222718',
  allowUrls: [
    /cgtrader\.com/,
    /assets\.cgtrader\.com/,
    /testcgt\.com/,
    /testcgt2\.com/,
    /testcgt3\.com/
  ],
  autoSessionTracking: true,
  ignoreErrors: knownNoisyIssues,
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
}


// Initialize Sentry with optional custom config
export const initSentry = (window, customConfig = {}) => {
  const config = { ...sentryConfig, ...customConfig }

  // Set up window references immediately so they're available for error handling
  window.Sentry = Sentry
  window.sendErrorToSentry = (error, { tags, extra } = {}) => {
    return Sentry.captureException(error, { tags, extra })
  }

  // Delay actual Sentry initialization until browser is idle to improve PageSpeed performance
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      Sentry.init(config)
    }, { timeout: 3000 }) // Max wait 3 seconds for Sentry initialization
  } else {
    // Fallback for browsers without requestIdleCallback support (e.g., Safari)
    setTimeout(() => {
      Sentry.init(config)
    }, 1000)
  }
}

// Set user information
export const setSentryUser = (uuid, username) => {
  if (uuid && uuid.length > 0) {
    Sentry.setUser({ id: uuid, username })
  }
}
